"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterValidationService = void 0;
var joi_1 = __importDefault(require("joi"));
var Result_1 = require("../../../../../models/concrete/Result");
var FilterValidationService = /** @class */ (function () {
    function FilterValidationService() {
        this.schemaForGetFiltersByCategorySlug = joi_1.default.object().keys({
            categorySlug: joi_1.default.string().required(),
            filters: joi_1.default.array().items(joi_1.default.object().keys({
                name: joi_1.default.string().required(),
                values: joi_1.default.array().items(joi_1.default.alternatives().try(joi_1.default.string(), joi_1.default.number())).required()
            })).required(),
            slugs: joi_1.default.array().items(joi_1.default.string()),
            expanded: joi_1.default.boolean().optional(),
            canceledOptions: joi_1.default.any().optional(),
        });
        this.schemaForGetFiltersByPromotionSlug = joi_1.default.object().keys({
            promotionSlug: joi_1.default.string().required(),
            filters: joi_1.default.array().items(joi_1.default.object().keys({
                name: joi_1.default.string().required(),
                values: joi_1.default.array().items(joi_1.default.alternatives().try(joi_1.default.string(), joi_1.default.number())).required()
            })).required(),
            slugs: joi_1.default.array().items(joi_1.default.string()),
            expanded: joi_1.default.boolean().optional(),
            canceledOptions: joi_1.default.any().optional()
        });
        this.schemaForGetFiltersByBrandSlug = joi_1.default.object().keys({
            brandSlug: joi_1.default.string().required(),
            filters: joi_1.default.array().items(joi_1.default.object().keys({
                name: joi_1.default.string().required(),
                values: joi_1.default.array().items(joi_1.default.alternatives().try(joi_1.default.string(), joi_1.default.number())).required()
            })).required(),
            slugs: joi_1.default.array().items(joi_1.default.string()),
            expanded: joi_1.default.boolean().optional(),
            canceledOptions: joi_1.default.any().optional(),
        });
        this.schemaForGetFiltersBySetSlug = joi_1.default.object().keys({
            setSlug: joi_1.default.string().required(),
            filters: joi_1.default.array().items(joi_1.default.object().keys({
                name: joi_1.default.string().required(),
                values: joi_1.default.array().items(joi_1.default.alternatives().try(joi_1.default.string(), joi_1.default.number())).required()
            })).required(),
            slugs: joi_1.default.array().items(joi_1.default.string()),
            expanded: joi_1.default.boolean().optional(),
            canceledOptions: joi_1.default.any().optional(),
        });
        this.schemaForGetAvailableFilterVariantsByCategory = joi_1.default.object().keys({
            categorySlug: joi_1.default.string().required(),
            filters: joi_1.default.array().items(joi_1.default.object().keys({
                name: joi_1.default.string().required(),
                values: joi_1.default.array().items(joi_1.default.alternatives().try(joi_1.default.string(), joi_1.default.number())).required()
            })).required(),
            slugs: joi_1.default.array().items(joi_1.default.string())
        });
        this.schemaForGetAvailableFilterVariantsByPromotion = joi_1.default.object().keys({
            promotionSlug: joi_1.default.string().required(),
            filters: joi_1.default.array().items(joi_1.default.object().keys({
                name: joi_1.default.string().required(),
                values: joi_1.default.array().items(joi_1.default.alternatives().try(joi_1.default.string(), joi_1.default.number())).required()
            })).required(),
            slugs: joi_1.default.array().items(joi_1.default.string()),
            canceledOptions: joi_1.default.any().optional()
        });
        this.schemaForGetAvailableFilterVariantsByBrand = joi_1.default.object().keys({
            brandSlug: joi_1.default.string().required(),
            filters: joi_1.default.array().items(joi_1.default.object().keys({
                name: joi_1.default.string().required(),
                values: joi_1.default.array().items(joi_1.default.alternatives().try(joi_1.default.string(), joi_1.default.number())).required()
            })).required(),
            slugs: joi_1.default.array().items(joi_1.default.string())
        });
        this.schemaForGetAvailableFilterVariantsBySet = joi_1.default.object().keys({
            setSlug: joi_1.default.string().required(),
            filters: joi_1.default.array().items(joi_1.default.object().keys({
                name: joi_1.default.string().required(),
                values: joi_1.default.array().items(joi_1.default.alternatives().try(joi_1.default.string(), joi_1.default.number())).required()
            })).required(),
            slugs: joi_1.default.array().items(joi_1.default.string())
        });
    }
    FilterValidationService.prototype.getAvailableFilterVariantsByCategoryData = function (data) {
        var error = this.schemaForGetAvailableFilterVariantsByCategory.validate(data).error;
        // debug
        console.debug('Validating get available filter variants by category data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    FilterValidationService.prototype.getAvailableFilterVariantsByPromotionData = function (data) {
        var error = this.schemaForGetAvailableFilterVariantsByPromotion.validate(data).error;
        // debug
        console.debug('Validating get available filter variants by promotion data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    FilterValidationService.prototype.getAvailableFilterVariantsByBrandData = function (data) {
        var error = this.schemaForGetAvailableFilterVariantsByBrand.validate(data).error;
        // debug
        console.debug('Validating get available filter variants by promotion data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    FilterValidationService.prototype.getAvailableFilterVariantsBySetData = function (data) {
        var error = this.schemaForGetAvailableFilterVariantsBySet.validate(data).error;
        // debug
        console.debug('Validating get available filter variants by set data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    FilterValidationService.prototype.getFiltersByCategorySlugData = function (data) {
        var error = this.schemaForGetFiltersByCategorySlug.validate(data).error;
        // debug
        console.debug('Validating get filters by category slug data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    FilterValidationService.prototype.getFiltersByPromotionSlugData = function (data) {
        var error = this.schemaForGetFiltersByPromotionSlug.validate(data).error;
        // debug
        console.debug('Validating get filters by promotion slug data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    FilterValidationService.prototype.getFiltersByBrandSlugData = function (data) {
        var error = this.schemaForGetFiltersByBrandSlug.validate(data).error;
        // debug
        console.debug('Validating get filters by promotion slug data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    FilterValidationService.prototype.getFiltersBySetSlugData = function (data) {
        var error = this.schemaForGetFiltersBySetSlug.validate(data).error;
        // debug
        console.debug('Validating get filters by set slug data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    return FilterValidationService;
}());
exports.FilterValidationService = FilterValidationService;
//# sourceMappingURL=FilterValidationService.js.map